module.exports = __webpack_public_path__ + "8d69e5d7b46ade01f1d8493dcdc5be99.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/watermelon.png
// module id = 2345
// module chunks = 0